import { Box, styled } from '@mui/material';

const StepperRow = styled(Box)`
  display: flex;
  gap: 10px;
  align-items: flex-start;
`;

export default StepperRow;
